module.exports = __webpack_public_path__ + "img/top@2x.775c43f0.png";